import { __decorate, __metadata } from "tslib";
import { IsBoolean, Length } from 'class-validator';
import { IsTruthyWhen } from '../../shared/validator/IsTruthyWhen';
/**
 * The court system's disclaimer message and its visibility
 */
export class DisclaimerConfiguration {
    /**
     * @param text Disclaimer markdown text
     * @param isVisible Whether the disclaimer will display in the UI
     */
    constructor(text, isVisible) {
        this.text = text;
        this.isVisible = isVisible;
    }
}
DisclaimerConfiguration.MAX_TEXT_LENGTH = 500;
__decorate([
    Length(0, DisclaimerConfiguration.MAX_TEXT_LENGTH),
    IsTruthyWhen('isVisible', true, {
        message: 'Text cannot be empty when disclaimer is visible.',
    }),
    __metadata("design:type", String)
], DisclaimerConfiguration.prototype, "text", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DisclaimerConfiguration.prototype, "isVisible", void 0);
export const DEFAULT_DISCLAIMER_CONFIGURATION = new DisclaimerConfiguration('', false);
